import { useEffect, useRef } from "react";

export const useContentHydration = (rehydrateDeps: any[]) => {
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = contentRef.current;
    if (element && typeof window !== "undefined") {
      const children = element.children;
      if (children.length > 0) {
        const firstChild = children[0] as HTMLElement;
        firstChild.style.marginTop = "0";
        firstChild.style.paddingTop = "0";

        const lastChild = children[children.length - 1] as HTMLElement;
        lastChild.style.marginBottom = "0";
        lastChild.style.paddingBottom = "0";
      }
    }
  }, [rehydrateDeps]);

  return { contentRef };
};
